import type { ComponentProps } from 'react'
import { useIntl } from 'react-intl'

import { type InputProps, InputWrapper } from '../inputWrapper/InputWrapper'
import { createInternalWrapperPropsAndId } from '../utility'
import { RawSelect } from './RawSelect'
import { getSortFn, type SortFn } from './Select.utils'

type Props<T> = ComponentProps<typeof RawSelect<T>> &
  InputProps & {
    sort?: 'automatic' | false | SortFn<T>
  }

export const Select = <T,>({
  wrapperProps,
  sort = 'automatic',
  ...fieldProps
}: Props<T>) => {
  const { locale } = useIntl()
  const { internalWrapperProps, id } = createInternalWrapperPropsAndId({
    wrapperProps,
    id: fieldProps.id,
  })

  return (
    <InputWrapper {...internalWrapperProps}>
      <RawSelect {...fieldProps} id={id} sortFn={getSortFn({ sort, locale })} />
    </InputWrapper>
  )
}
